	<template>
		
	    <div id="qrcode"></div>
	</template>
	
	<script>
	//引入qrcodejs2
	import QRCode from 'qrcodejs2'
	
	export default {
	    name: 'Test',
	    mounted(){
	        this.init()
	    },
	    methods:{
	        init(){
	            new QRCode(document.getElementById('qrcode'), {
	                text: location.href, //要生成二维码的网址
	                width: 256,  //图像宽度
	                height: 256, //图像高度
	                colorDark: '#000000',  //前景色
	                colorLight: '#ffffff', //背景色
	                margin:0, //外边距
	                correctLevel: QRCode.CorrectLevel.L //容错级别。属性值有：QRCode.CorrectLevel.L、QRCode.CorrectLevel.M、QRCode.CorrectLevel.Q、QRCode.CorrectLevel.H
	            })	
	        }
	    }
	}
	</script>


// WEBPACK FOOTER //
// src/components/views/jjgh/er.vue